import { render } from "./SurveyQuestionType1AnswerEditor.vue?vue&type=template&id=3c579e84"
import script from "./SurveyQuestionType1AnswerEditor.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionType1AnswerEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__